<template>
  <div class="user">
    <div class="buttons">
      <div class="button" @click="openSearch">
        <img src="@/assets/images/search.svg"/>
      </div>
      <div @click="handleLogOut" class="button"><img src="@/assets/images/log-out.svg"/></div>
    </div>
    <div class="details">
      <img class="img" :src="userDetails.userPicture" />
      <div>
        <span class="name">{{ userDetails.firstName + " " + userDetails.lastName }}</span>
        <span class="type">{{ userDetails.isAdmin ? "Administrator" : "Operator" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationUserInfo',
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {
      user: String,
      type: String,
      image: String,
    }
  },
  mounted() {},
  methods: {
    handleLogOut(){
      this.$store
        .dispatch("logout")
        .then(() => this.$router.push("/login"))
        .catch(err => console.log(err));
    },
    openSearch() {
      this.$router.push('/search', true)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/nav";

div.button:hover {
  cursor: pointer;
}
</style>
